<template>
	<div>
		<div class="first_line">
			<el-button type="primary" size="small" @click="addRoster">新建班次</el-button>
		</div>
		<div>
			<el-table :cell-style="{'text-align':'center'}"
				:header-cell-style="{background:'#F2F2F4','text-align':'center'}" ref="multipleTable" :data="tableData"
				tooltip-effect="dark" style="width: 100%">
				<el-table-column prop="desc" label="班次名称">
				</el-table-column>
				<el-table-column prop="name" label="班次时间">
					<template slot-scope="scope">
						{{scope.row.startWorkTime}}-{{scope.row.endWorkTime}}
					</template>
				</el-table-column>
				<el-table-column prop="storeNames" label="所属门店" width="350px"></el-table-column>
				<el-table-column prop="earlyTime" label="最早打卡时间" width="110px"></el-table-column>
				<el-table-column prop="middleTime" label="班次中点" width="110px"></el-table-column>
				<el-table-column prop="lastTime" label="最晚打卡时间" width="110px"></el-table-column>
				<el-table-column label="状态" width="70px">
					<template slot-scope="scope">
						{{scope.row.status==1?"使用中":""}}
						{{scope.row.status==2?"已失效":""}}
					</template>
				</el-table-column>
				<el-table-column width="120px" label="操作">
					<template slot-scope="scope">
						<div v-if="scope.row.status==1">
							<el-button type="text" @click="deitpaibans(scope.row.id)">编辑</el-button>
							<el-button type="text" @click="invalid(scope.row.id)">失效</el-button>
						</div>
						<div v-if="scope.row.status==2">
							<span style="color: #AAAAAA;position: relative;left:-10px;">已失效</span>
							<el-button type="text" @click="dele(scope.row.id)">
								<span style="color: red;">删除</span>
							</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagescg">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="filter.pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="filter.pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="新建班次" :visible.sync="dialogVisible" width="600px">
			<el-form label-width="80px">
				<el-form-item label="班次名称">
					<el-input v-model="form.desc" size="small"></el-input>
				</el-form-item>
				<el-form-item label="班次时间">
					<el-time-select size="small" v-model="form.startWorkTime" :picker-options="{
						start: '00:00',
						step: '00:10',
						end: '24:00'
					}" placeholder="选择时间">
					</el-time-select>
					<span style="margin-left: 10px;margin-right: 10px;">至</span>
					<el-time-select size="small" v-model="form.endWorkTime" :picker-options="{
						start: '00:00',
						step: '00:10',
						end: '24:00'
					}" placeholder="选择时间">
					</el-time-select>
				</el-form-item>
				<el-form-item label="添加门店">
					<el-tag size="mini" v-for="item in stores" :key="item" style="margin-right:10px">
						{{ item.title }}
					</el-tag>
					<div class="add" @click="addstore=true">
						+选择门店
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addclass">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="修改排班" :visible.sync="deitpaiban" width="650px">
			<el-form label-width="120px">
				<el-form-item label="班次名称">
					<el-input v-model="deit.desc" size="small"></el-input>
				</el-form-item>
				<el-form-item label="班次时间">
					<el-time-select size="small" v-model="deit.startWorkTime"
						:picker-options="{start: '00:00',step: '00:10',end: '24:00'}" placeholder="选择时间">
					</el-time-select>
					<span style="margin-left: 10px;margin-right: 10px;">至</span>
					<el-time-select size="small" v-model="deit.endWorkTime"
						:picker-options="{start: '00:00',step: '00:10',end: '24:00'}" placeholder="选择时间">
					</el-time-select>
				</el-form-item>
				<el-form-item label="最早打卡时间">
					<el-time-select size="small" v-model="deit.earlyTime"
						:picker-options="{start: '00:00',step: '00:10',end: '24:00'}" placeholder="选择时间">
					</el-time-select>
				</el-form-item>
				<el-form-item label="班次中点时间">
					<el-time-select size="small" v-model="deit.middleTime"
						:picker-options="{start: '00:00',step: '00:10',end: '24:00'}" placeholder="选择时间">
					</el-time-select>
				</el-form-item>
				<el-form-item label="最晚打卡时间">
					<el-time-select size="small" v-model="deit.lastTime"
						:picker-options="{start: '00:00',step: '00:10',end: '24:00'}" placeholder="选择时间">
					</el-time-select>
				</el-form-item>
				<el-form-item label="午餐时间">
					<el-input-number v-model="deit.mainTime" size="small"></el-input-number>分钟
				</el-form-item>
				<el-form-item label="晚餐时间">
					<el-input-number v-model="deit.lightTime" size="small"></el-input-number>分钟
				</el-form-item>
				<el-form-item label="午餐开始时间">
					<el-time-select placeholder="午餐开始时间" v-model="deit.lunchStartTime"
						:picker-options="{start: '11:00',step: '00:15',end: '15:00'}"></el-time-select>
				</el-form-item>
				<el-form-item label="午餐结束时间">
					<el-time-select placeholder="午餐结束时间" v-model="deit.lunchEndTime"
						:picker-options="{start: '12:00',step: '00:15',end: '15:00'}"></el-time-select>
				</el-form-item>
				<el-form-item label="晚餐开始时间">
					<el-time-select placeholder="晚餐开始时间" v-model="deit.dinnerStartTime"
						:picker-options="{start: '16:00',step: '00:15',end: '19:00'}"></el-time-select>
				</el-form-item>
				<el-form-item label="晚餐结束时间">
					<el-time-select placeholder="晚餐结束时间" v-model="deit.dinnerEndTime"
						:picker-options="{start: '18:00',step: '00:15',end: '20:00'}"></el-time-select>
				</el-form-item>
				<el-form-item label="添加门店">
					<div class="add" @click="addstore=true">
						+选择门店
					</div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="deitpaiban = false">取 消</el-button>
				<el-button type="primary" @click="changepaiban">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="添加门店" :visible.sync="addstore" width="60%">
			<el-input v-model="storelist.title" size="small" style="width: 200px;" placeholder="请输入门店名称"></el-input>
			<el-button type="primary" @click="getstore" style="margin-left: 20px;" size="small">搜索</el-button>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-table :data="dataList.rows" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
					style="width: 100%">
					<el-table-column align="center" width="100" label="选择">
						<template slot-scope="scope">
							<el-checkbox v-if="deitpaiban" style="width: 25px;overflow: hidden;" v-model="deit.storeIds"
								:label="scope.row.id" @change="showStore"></el-checkbox>
							<el-checkbox v-if="dialogVisible" style="width: 25px;overflow: hidden;"
								v-model="form.storeIds" :label="scope.row.id" @change="showStore"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column label="城市" align="center">
						<template slot-scope="scope">
							{{scope.row.title.split("-")[0]}}
						</template>
					</el-table-column>
					<el-table-column align="center" label="店名">
						<template slot-scope="scope">
							{{scope.row.title.split("-")[1]}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="add_botom" style="display: flex;">
				<el-pagination @current-change="handleCurrentChange2" :current-page="storelist.page"
					:page-size="storelist.size" layout="total, prev, pager, next" :total="storelist.total">
				</el-pagination>
			</div>
			<div class="add_botom_nei">
				<el-button size="small" @click="clearstore">取消</el-button>
				<el-button size="small" type="primary" @click="addstore=false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				deit: {
					desc: "",
					startWorkTime: "",
					endWorkTime: "",
					earlyTime: "",
					middleTime: "",
					lastTime: "",
					storeIds: []
				},
				stores: [],
				//修改排班
				deitpaiban: false,
				dialogVisible: false,
				total: 0,
				addstore: false,
				form: {
					desc: "",
					startWorkTime: "",
					endWorkTime: "",
					earlyTime: "",
					middleTime: "",
					lastTime: "",
					lunchStartTime: '',
					lunchEndTime: '',
					dinnerStartTime: '',
					dinnerEndTime: '',
					storeIds: []
				},
				storelist: {
					title: "",
					page: 1,
					size: 10,
					total: 0
				},
				dataList: [],
				filter: {
					pageNum: 1, // 页码
					pageSize: 10 // 条数
				},
				tableData: [],
				storeName: "", // 店铺名称
				currentPage4: 4
			};
		},
		mounted() {
			this.getlist()
			this.getstore()
		},
		methods: {
			showStore() {
				this.stores = [];
				this.dataList.rows.forEach(res => {
					this.form.storeIds.forEach(id => {
						if (id == res.id) this.stores.push(res)
					})
				})
				this.dataList.rows.forEach(res => {
					this.deit.storeIds.forEach(id => {
						if (id == res.id) this.stores.push(res)
					})
				})
			},
			addRoster() {
				this.dialogVisible = true;
				this.form = {
					desc: "",
					startWorkTime: "",
					endWorkTime: "",
					storeIds: []
				}
				this.stores = []
			},
			// 修改排班
			changepaiban() {
				this.$http.post("dcheckuser/updateDRoster", JSON.stringify(this.deit)).then(function(res) {
					if (res.body.code == "200") {
						this.$message.success("修改成功")
						this.getlist()
						this.deit = this.form = {
							desc: "",
							startWorkTime: "",
							endWorkTime: "",
							earlyTime: "",
							middleTime: "",
							lastTime: "",
							storeIds: []
						};
						this.deitpaiban = false
					}
				}, function() {
					this.$message.error("请求失败")
				})
			},
			deitpaibans(id) {
				for (let i in this.tableData) {
					if (id == this.tableData[i].id) {
						let a = []
						if (this.tableData[i].storeId.split(",").length > 0) {
							for (let j in this.tableData[i].storeId.split(",")) {
								a[j] = Number(this.tableData[i].storeId.split(",")[j])
							}
						}
						this.deit = {
							id: id,
							desc: this.tableData[i].desc,
							startWorkTime: this.tableData[i].startWorkTime,
							endWorkTime: this.tableData[i].endWorkTime,
							earlyTime: this.tableData[i].earlyTime,
							middleTime: this.tableData[i].middleTime,
							lastTime: this.tableData[i].lastTime,
							lunchStartTime: this.tableData[i].lunchStartTime,
							lunchEndTime: this.tableData[i].lunchEndTime,
							dinnerStartTime: this.tableData[i].dinnerStartTime,
							dinnerEndTime: this.tableData[i].dinnerEndTime,
							mainTime: this.tableData[i].mainTime,
							lightTime: this.tableData[i].lightTime,
							storeIds: a,
						}
					}
				}
				this.showStore()
				this.deitpaiban = true
			},
			//获取门店
			getstore() {
				this.$http.get("store/list?title=" + this.storelist.title + "&page=" + this.storelist.page + "&size=" +
					this.storelist.size).then(function(res) {
					if (res.body.code == 200) {
						this.dataList = res.body.data
						this.storelist.total = res.body.data.total
					}
				}, function(err) {
					this.$message.error("请求失败")
				})
			},
			// 取消选择门店则表示清空
			clearstore() {
				this.form.storeIds = []
				this.addstore = false;
			},
			clearForm() {
				this.dialogVisible = false
				this.deit = this.form = {
					desc: "",
					startWorkTime: "",
					endWorkTime: "",
					storeIds: []
				};
				this.stores = []
			}, //新建班次
			addclass() {
				if (this.form.storeIds) {
					this.form.storeId = this.form.storeIds.toString();
				}
				this.$http.post("dcheckuser/saveDRoster", JSON.stringify(this.form)).then(function(res) {
					if (res.body.code == "200") {
						this.$message.success("添加成功")
						this.clearForm()
						this.getlist()
					} else {
						this.$message.error("添加失败")
						this.clearForm()
					}
				}, function() {
					this.$message.error("请求失败")
				})
			},
			dele(id) {
				this.$confirm('此操作将永久删除, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let arr = {
						id: id
					}
					this.$http.post("dcheckuser/delDRosterById", JSON.stringify(arr)).then(function(res) {
						if (res.body.code == "200") {
							this.$message.success("删除成功");
							this.getlist();
						}
					}, function() {
						this.$message.error("请求失败")
					})
				}).catch(() => {

				});
			},
			invalid(id) {
				let arr = {
					id: id
				}
				this.$http.post("dcheckuser/updateDRosterStatus", JSON.stringify(arr)).then(function(res) {
					if (res.body.code == "200") {
						this.$message.success("失效成功")
						this.getlist()
					}
				}, function() {
					this.$message.error("请求失败")
				})
			},
			getlist() {
				this.$http.post("dcheckuser/findDRosterData", JSON.stringify(this.filter)).then(function(res) {
					if (res.body.code == "200") {
						this.tableData = res.body.data
						this.total = res.body.total
					}
				}, function() {
					this.$message.error("请求失败")
				})
			},
			handleSizeChange(val) {
				this.filter.pageSize = val
				this.getlist()
			},
			handleCurrentChange(val) {
				this.filter.pageNum = val
				this.getlist()
			},
			handleCurrentChange2(val) {
				this.storelist.page = val
				this.getstore()
			}
		},
	};
</script>
<style lang="less" scoped>
	.add {
		cursor: pointer;
		display: inline-block;
		border: 1px dashed #82848A;
		line-height: 2.5;
		padding: 8px;
		padding-top: 0px;
		padding-bottom: 0px;
		color: #82848A;
	}

	.first_line {
		margin: 20px 0;
		margin-top: 0;
		display: flex;
		justify-content: space-between;

		.right_warp {
			display: flex;
			align-items: center;
			font-size: 16px;
			color: #3e3e3e;

			.el-select {
				width: 120px;
			}

			.el-input {
				width: 180px;
			}

			.jul {
				margin-left: 10px;
			}
		}
	}

	.pagescg {
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.add_botom {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
	}

	.add_botom_nei {
		margin-top: 15px;
		margin-left: 44%;
	}
</style>